module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/soal/soal.component.css
// module id = ./src/app/components/soal/soal.component.css
// module chunks = main